import React from "react";
import "./login.scss";
import { Link, NavLink } from "react-router-dom";
import { images } from "../../utils/customFn";
import { EyeClosedIcon, EyeOpenIcon, IconPassword } from "../../icon/icons";
import useLogin from "./login";
import { useSelector } from "react-redux";

const Login = () => {
  const {
    formData,
    formErrors,
    isPasswordVisible,
    loading,
    handleChange,
    setIsPasswordVisible,
    handleSubmit,
  } = useLogin();

  const { isUserLoggedIn } = useSelector((state) => state.userAuth);

  return (
    <div className="login_main_page">
      <div className="page_side_pd">
        <div className="page_flex_data">
          <div className="page_form_data">
            <div className="form-inner-data">
              <div className="logo_container">
                <img src={images["side_logo.png"]} alt="" className="logo" />
              </div>
              <div className="page_heading"></div>
              <form onSubmit={handleSubmit}>
                <div className="password-fields">
                  <div className="all_input">
                    <label>Email</label>
                    <input
                      type="text"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter email"
                    />
                    {formErrors.email && (
                      <small className="error-message text-danger">
                        {formErrors.email}
                      </small>
                    )}
                  </div>

                  <div className="all_input">
                    <div className="d-flex justify-content-between">
                      <label className="d-block">Password</label>
                      <div className="text-right forget_password_btn">
                        <Link to={"/forget-password"}>forgot password ? </Link>
                      </div>
                    </div>
                    <div className="password-input-main password-input-wrapper">
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Enter password"
                      />
                      <div className="">
                        <button
                          type="button"
                          className="password-toggle"
                          onClick={() =>
                            setIsPasswordVisible(!isPasswordVisible)
                          }
                        >
                          {isPasswordVisible ? (
                            <EyeOpenIcon />
                          ) : (
                            <EyeClosedIcon />
                          )}
                        </button>
                      </div>
                    </div>

                    {formErrors.password && (
                      <small className="error-message text-danger">
                        {formErrors.password}
                      </small>
                    )}
                  </div>
                </div>
                <div className="btn_main_login">
                  <button
                    type="submit"
                    className="btn-comman-main"
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Log In"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
